import Institution from '../../models/Institution';
import PaginationParams from '../../models/PaginationParams';
import Syllabus from '../../models/Syllabus';

export interface NewOptionAutocompleteOption {
  id: string;
  key: string;
  name: string;
  inputValue: string;
  shortName: string;
  removeName: boolean;
}

export class NewOptionAutocompleteOptionClass implements NewOptionAutocompleteOption {
  id: string;
  key: string;
  name: string;
  inputValue: string;
  shortName: string;
  removeName: boolean;

  constructor(
    id = '',
    key = '',
    name = '',
    inputValue = '',
    shortName = '',
    removeName = false
  ) {
    this.id = id;
    this.key = key;
    this.name = name;
    this.inputValue = inputValue;
    this.shortName = shortName;
    this.removeName = removeName;
  }

  static fromInstitution(institution: Institution): NewOptionAutocompleteOptionClass {
    return new NewOptionAutocompleteOptionClass(institution.id, institution.id, institution.name, institution.name, institution.short_name, undefined);
  }

  static toInstitution(value: NewOptionAutocompleteOptionClass | null, institutions: Institution[]): Institution | undefined {
    let institution: Institution | undefined;
    if (value?.id === '') {
      institution = {
        id: '',
        name: value.name,
        removeName: value?.removeName
      }
      return institution;
    }
    institution = institutions.find((institution) => {
      const compare = institution?.id === value?.key;
      return compare;
    });
    if (typeof institution !== 'undefined') {
      institution = {
        ...institution,
        removeName: value?.removeName
      }
    }
    return institution;
  }

  static fromSyllabus(syllabus: Syllabus): NewOptionAutocompleteOptionClass {
    return new NewOptionAutocompleteOptionClass(syllabus.id, syllabus.id, syllabus.name, syllabus.name, undefined);
  }

  static toSyllabus(value: NewOptionAutocompleteOptionClass | null, syllabuses: Syllabus[]): Syllabus | undefined {
    let syllabus: Syllabus | undefined;
    if (value?.id === '') {
      syllabus = {
        id: '',
        name: value.name,
        removeName: value?.removeName
      }
      return syllabus;
    }
    syllabus = syllabuses.find((syllabus) => {
      const compare = syllabus?.id === value?.key;
      return compare;
    });
    if (typeof syllabus !== 'undefined') {
      syllabus = {
        ...syllabus,
        removeName: value?.removeName
      }
    }
    return syllabus;
  }
}

interface NewOptionAutocompleteEventsInterface<T> {
  setValue: (value: NewOptionAutocompleteOption | null) => void,
  onChange?: () => void,
  fetchFunc: (params: T & PaginationParams) => void
}

interface NewOptionAutocompletePropsInterface {
  options: NewOptionAutocompleteOption[],
  value: NewOptionAutocompleteOption | null,
  placeholder?: string,
  label: string,
  disableCondition?: boolean,
  noOptionsText: string,
  addOptionText?: string,
  alertMessage?: string,
  conditionToShowAlertMessage?: boolean,
  optionNotFoundText?: string,
  required?: boolean,
  maxLength?: number,
  addOption?: boolean,
  uppercase?: boolean
  id?: string
  testId: string
}

export type NewOptionAutocompleteProps<T = any> = NewOptionAutocompletePropsInterface & NewOptionAutocompleteEventsInterface<T>;
